export default __webpack_public_path__ + "static/media/play.558f553f.svg";